import type {PropsWithChildren} from 'react';
import {PublicBadge} from '../../../../components/public-badge';
import {RequiredBadge} from '../../../../components/required-badge';
import styles from './form-row.module.css';
import {type FormFieldPath} from '@/features/company-registration/form';

type Props = PropsWithChildren<{
  readonly labelText: string;
  readonly isRequired?: boolean;
  readonly isPublic?: boolean;
  readonly htmlFor?: FormFieldPath;
}>;

export function FormRow({
  labelText,
  htmlFor,
  isRequired = false,
  isPublic = false,
  children,
}: Props) {
  return (
    <div className={styles.row}>
      <div className={styles.labelCell}>
        {htmlFor === undefined ? (
          <p className={styles.labelText}>{labelText}</p>
        ) : (
          <label htmlFor={htmlFor} className={styles.labelText}>
            {labelText}
          </label>
        )}

        {(isPublic || isRequired) && (
          <div className={styles.badges}>
            {isPublic && <PublicBadge />}
            {isRequired && <RequiredBadge />}
          </div>
        )}
      </div>

      <div className={styles.fieldCell}>{children}</div>
    </div>
  );
}
